import { Network } from '../../../../utils/network'

async function getKycDocuments(searchValue) {
  const usersResponse = await sendRequest(searchValue)
  const parsedUserResponse = parseResponse(usersResponse, searchValue)
  return parsedUserResponse
}

async function sendRequest(searchValue) {
  let url = 'https://apis.ecoxurf.com/kyc/fetch/data/all/marketplace'
  url += `?search=${searchValue}&searchKey=locationCountry,email,lastName,firstName,birthDate,phoneNumber,city,locality,district,postalCode,address,jobTitle,idDocCreationCountry,idDocNumber,idDocCreationDate,idDocExpiryDate,companyName,countryCode,addresss,state,commercialLicenceId,website`
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  console.log(response)
  if (response && response.status.code === 200) {
    let users = response.response.data || []
    users = users
      .filter(document => document.validationStatus !== 'notFilled')
      .map(doc => ({
        ...doc,
        submitionDate: doc.submitionDate || doc.createdAt,
      }))
      .sort((el1, el2) => el2.submitionDate - el1.submitionDate)

    return {
      success: true,
      data: users,
    }
  }
  if (response.status.code === 0) {
    return {
      success: false,
      message: 'error',
      networkError: true,
    }
  }
  return {
    success: false,
    message: 'error',
  }
}

export { getKycDocuments }
